import axiosInstance from "../../../../../api/axiosInstance";

export async function signUpload({ filename, type, kind, businessId }) {
  const { data } = await axiosInstance.post(
    "/utils/uploads/sign",
    { filename, type, kind },                // kind: 'photo' | 'video'
    { params: businessId ? { business_id: businessId } : {} }
  );
  // data: { uploadUrl, objectKey }
  return data;
}

export async function putToSignedUrl(uploadUrl, file) {
  console.log('fuckity fuck');
  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!res.ok) throw new Error(`Upload failed (HTTP ${res.status})`);
}

export async function uploadFileToGCS(file, kind, businessId) {
  const { uploadUrl, objectKey } = await signUpload({
    filename: file.name,
    type: file.type,
    kind,
    businessId,
  });
  await putToSignedUrl(uploadUrl, file);
  return objectKey; // we’ll send this in save-all payload
}
